export default ".action_button {\n  cursor: pointer;\n}"